import { MutableRefObject, RefObject, useCallback, useEffect, useRef } from 'react';
import { GridApiPro } from '@mui/x-data-grid-pro';
import { DATA_GRID_EVENTS } from 'components/common/dataGrid/constants';

const PANEL_CONTENT_SELECTOR = '.MuiDataGrid-panelContent';

type UseAutoScrollOnFilterAddResult = {
  formsAreaRef: RefObject<HTMLDivElement>;
};

export function useAutoScrollOnFilterAdd(
  apiRef: MutableRefObject<GridApiPro>
): UseAutoScrollOnFilterAddResult {
  const formsAreaRef = useRef<HTMLDivElement>(null);
  const previousFilterCountRef = useRef(0);

  const scrollToBottom = useCallback(() => {
    const panelContent = formsAreaRef.current?.querySelector<HTMLDivElement>(
      PANEL_CONTENT_SELECTOR
    );

    if (!panelContent) {
      return;
    }

    requestAnimationFrame(() => {
      panelContent.scrollTop = panelContent.scrollHeight;
    });
  }, []);

  useEffect(() => {
    const api = apiRef.current;

    if (!api.subscribeEvent) {
      return;
    }

    previousFilterCountRef.current =
      api.state.filter.filterModel.items.length;

    return api.subscribeEvent(
      DATA_GRID_EVENTS.FILTER_MODEL_CHANGE,
      ({ items }) => {
        if (items.length > previousFilterCountRef.current) {
          scrollToBottom();
        }

        previousFilterCountRef.current = items.length;
      }
    );
  }, [apiRef, scrollToBottom]);

  return {
    formsAreaRef,
  };
}
